import
{
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBarChart } from '@fortawesome/free-solid-svg-icons';

const TiposInformacion = ({ labels, data: tiposInformacion }) =>
{
    ChartJS.register
    (
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
    );

    const options =
    {
        maintainAspectRatio: false,
        indexAxis: 'y',
        elements:
        {
            bar:
            {
                borderRadius: 12,
                maxBarThickness: 34,
                borderWidth: 1.5,
                borderColor: 'rgb(255, 99, 132)',
            },
        },
        responsive: true,
        plugins:
        {
            legend:
            {
                position: 'bottom',
                labels:
                {
                    boxWidth: 12,
                    padding: 14,
                    color: '#343a40',
                },
            },
            title:
            {
                display: false,
            },
            tooltip:
            {
                callbacks:
                {
                    label: function (context)
                    {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.x !== null) { label += context.parsed.x.toLocaleString('es-CL'); }
                        return label;
                    },
                },
            },
        },
        scales:
        {
            x:
            {
                grid:
                {
                    color: 'rgba(100, 100, 100, 0.08)',
                },
                ticks:
                {
                    callback: function (value)
                    {
                        return value.toLocaleString('es-CL');
                    },
                    color: '#343a40',
                },
            },
        },
    };

    const data =
    {
        labels: labels,
        datasets:
        [
            {
                label: 'Núm. Archivos',
                data: tiposInformacion,
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.45)',
            },
        ],
    };

    return (
        <div className="card border rounded-5 shadow-sm mb-4">
            <div className="card-header rounded-top-5 bg-white border-bottom py-3 d-flex align-items-center gap-2">
                <FontAwesomeIcon className="text-primary" icon={faBarChart} />
                {'Gráfico de Tipos de Información'}
            </div>
            <div className="card-body p-3" style={{ minHeight: '300px' }}><Bar options={options} data={data} /></div>
        </div>
    );
}

export default TiposInformacion;
